import React from 'react';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import styles from './PostCheckout.module.css';

const Cancel = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.card}>
        <div className={styles.iconWrapperCancel}>
          <XCircle size={64} />
        </div>
        <h1>Checkout Cancelled</h1>
        <p className={styles.subtitle}>
          Your order was not processed and no charges were made.
        </p>

        <div className={styles.helpBox}>
          <div className={styles.helpHeader}>
            <HelpCircle size={20} />
            <span>Need Help?</span>
          </div>
          <p>If you experienced a technical issue or have questions about tickets, please contact our support team.</p>
        </div>

        <div className={styles.buttonGroup}>
          <button
            className={styles.secondaryBtn}
            onClick={() => window.location.href = '/'}
          >
            <ArrowLeft size={16} style={{ marginRight: '8px' }} />
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cancel;